<template>
    <dash
        icon="fa fa-book"
        titulo="DESPESAS"
        subTitulo="GERENTE"
        @click.native="$router.push({ name: 'DespesasGerais_Gerentes_Despesas' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>